<template>
  <CustomPage title="消息">
    <div slot="content" style="height: 100%">
      <div class="message-container p-3">
        <div
          class="flex items-center p-3 lightshadow rounded-sm"
          @click="qiyuOpen"
        >
          <div
            style="width: 40px; height: 40px;"
            class="avatar flex-grow-0 van-hairline--surround"
          >
            <img
              :src="require('@/assets/setting/avatar.png')"
              class="w-full h-full rounded-full"
            />
          </div>
          <div class="flex-grow mx-2">小云客服</div>
          <div v-if="qiyuTotal" class="badge">
            {{ qiyuTotal }}
          </div>
          <Icon name="arrow" />
        </div>
        <div
          v-show="messageList.length"
          class="flex justify-end my-2"
          @click="readAll"
        >
          <div>设为已读</div>
        </div>
        <div
          v-for="item in messageList"
          :key="item.id"
          class="flex p-3 mb-2 lightshadow"
          @click="readDetail(item.id)"
        >
          <div class="m-1">
            <div class="badge" v-if="!item.readFlag"></div>
            <div
              style="width: 42px; height: 42px; background: #e67b35"
              class="-m-1 rounded-full flex justify-center items-center"
            >
              <img class="h-1/2 w-1/2" src="@/assets/message/喇叭.svg" alt="" />
            </div>
          </div>
          <div class="box">
            <div class="title">
              <div class="title-l van-ellipsis">{{ item.title }}</div>
              <div class="title-r">
                {{ dayjs(item.sendTime).format('YYYY-MM-DD') }}
              </div>
            </div>
            <div class="cont van-ellipsis">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import Bus from '@/utils/bus'
import CustomPage from '@/components/custom-page.vue'
import CustomView from '@/components/custom-view'
import { getMessage, readAll } from './webApi'
import { Icon } from 'vant'
import { isWechatMP } from '@/utils/qiyukf'
import { getToken } from '@/utils/auth'

export default {
  components: { CustomPage, CustomView, Icon },
  created() {
    this.getData()
    Bus.$on('refreshMessageData', this.getData)
  },
  updated() {
    // 客服消息监听
    if (!isWechatMP()) {
      ysf('onunread', function(result) {
        this.qiyuTotal = result.total
      })
    }
  },
  data() {
    return {
      qiyuTotal: 0,
      messageList: [],
    }
  },
  methods: {
    readDetail(id) {
      this.$router.push({
        path: this.$route.fullPath + '/messageDetail',
        query: { id },
      })
    },
    getData() {
      console.log('dsds')
      this.$store.dispatch('app/showLoading')
      getMessage()
        .then(({ data }) => {
          this.$store.dispatch('app/hideLoading')
          this.messageList = data
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    readAll() {
      this.$store.dispatch('app/showLoading')
      readAll()
        .then((res) => {
          this.getData()
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    // 打开客服
    qiyuOpen() {
      if (!isWechatMP()) {
        ysf('onready', function() {
          ysf('open')
        })
      } else {
        const customerId = this.$store.state.user.customerId
        const token = getToken()
        const Authorization = 'Bearer ' + token
        this.wxjs.miniProgram.navigateTo({
          url: `/pages/kf/kf?customerId=${customerId}&Authorization=${Authorization}`,
          success: function(res) {
            console.log('kfres success', res)
          },
          fail: function(res) {
            console.log('kfres fail', res)
          },
          events: {
            acceptDataFromOpenedPage: function(data) {
              console.log('kf', data)
            },
          },
          complete: function(res) {
            console.log('kfres complete', res)
          },
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.avatar {
  &::after {
    border-radius: 100%;
  }
}
.m-1 {
  position: relative;
}
.badge {
  position: absolute;
  top: -18px;
  right: -18px;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background: #c82d26;
  color: #fff;
  font-size: 20px;
  line-height: 30px;
  padding-top: 4px;
  text-align: center;
}
.box {
  flex: 1;
  min-width: 0;
  padding-left: 30px;
  padding-top: 8px;
  .title {
    display: flex;
    justify-content: space-between;
    .title-l {
      flex: 1;
      min-width: 0;
      font-size: 28px;
      line-height: 28px;
      color: #232323;
    }
    .title-r {
      font-size: 24px;
      color: #8e8e93;
      line-height: 24px;
    }
  }
  .cont {
    padding-top: 16px;
    font-size: 24px;
    color: #8e8e93;
    line-height: 24px;
  }
}
</style>
